import { UseUserQuery } from '../generated/types';
import { SetUserProps } from '../hooks/useUser';

type UseUserQueryUser = NonNullable<UseUserQuery['user']>;

export const NULL_USER: UseUserQueryUser = {
  __typename: 'User',
  accessToken: null,
  clientTier: null,
  countryCode: '',
  email: null,
  firstName: null,
  hasPassword: null,
  id: null,
  isAmazonConnected: null,
  isFacebookConnected: null,
  isLoggedIn: false,
  isMember: null,
  lastName: null,
  phone: null,
  statusLevel: null,
  userLoyaltyStatus: null,
  twoFactorAuthAppEnabled: false,
  twoFactorAuthTextMessageEnabled: false
};

export const serializeUser = ({ ...user }: UseUserQueryUser | SetUserProps) => JSON.stringify(user);

export const parseUser = (cookie: string): UseUserQueryUser => {
  let user;
  try {
    user = JSON.parse(cookie);
  } catch (error) {
    user = {};
  }
  return { ...NULL_USER, ...user };
};
